module.exports = __webpack_public_path__ + "static/img/07.dd364ca8.jpg";